module.exports = __webpack_public_path__ + "img/7.59cdfa6.png";